import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const errMsg = (e, fallback = "Something went wrong") =>
  e?.response?.data?.detail && typeof e.response.data.detail === "string"
    ? e.response.data.detail
    : fallback;

// POST with a timeout, retried once on a network failure (never on an HTTP error) - for the kiosk on a weak link.
export const postRetry = async (path, body, { tries = 2, timeout = 8000 } = {}) => {
  let err;
  for (let i = 0; i < tries; i += 1) {
    try { return await api.post(path, body, { timeout }); } catch (e) { err = e; if (e.response) throw e; }
  }
  throw err;
};
